'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stackedStateFromNewProps = exports.onChangeStackedMode = exports.isStackedDimActive = exports.stackedModeOptions = exports.onChangeStackedDimension = exports.toStackedSingularity = exports.isStacked = undefined;
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _defineProperty2 = require('babel-runtime/helpers/defineProperty');
var _defineProperty3 = _interopRequireDefault(_defineProperty2);
var _stackedModes;
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _constants = require('../constants');
var _utils = require('./utils');
var _ = require('../');
var _focus = require('./focus');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var getStackedDimension = (0, _utils.getPropertyDimension)('stackedDimension');
var stackedModes = (_stackedModes = {}, (0, _defineProperty3.default)(_stackedModes, _constants.PERCENT, _constants.PERCENT), (0, _defineProperty3.default)(_stackedModes, _constants.VALUES, _constants.VALUES), _stackedModes);
var isStacked = exports.isStacked = function isStacked(type) {
  return type === _constants.STACKED_BAR || type === _constants.STACKED_ROW;
};
var toStackedState = function toStackedState(dimension, mode) {
  return {
    stackedDimension: (0, _utils.toState)(dimension),
    stackedMode: mode
  };
};
var toStackedSingularity = exports.toStackedSingularity = function toStackedSingularity(state) {
  return {
    id: R.prop('stackedDimension', state),
    mode: R.prop('stackedMode', state),
    limit: 5
  };
};
var onChangeStackedDimension = exports.onChangeStackedDimension = function onChangeStackedDimension(_ref, state) {
  var data = _ref.data;
  return function (value) {
    var dimension = getStackedDimension(data, {
      stackedDimension: value
    });
    if (R.isNil(dimension)) {
      return {};
    }
    return {
      stackedDimension: (0, _utils.toState)(dimension),
      highlight: [],
      baseline: []
    };
  };
};
var stackedModeOptions = exports.stackedModeOptions = [{
  value: _constants.VALUES
}, {
  value: _constants.PERCENT
}];
var isStackedDimActive = exports.isStackedDimActive = function isStackedDimActive(_ref2) {
  var data = _ref2.data,
    type = _ref2.type;
  var _splitDimensions = (0, _.splitDimensions)(data),
    values = _splitDimensions.values;
  if (R.length(values) < 2) {
    return false;
  }
  return isStacked(type);
};
var onChangeStackedMode = exports.onChangeStackedMode = function onChangeStackedMode(value) {
  return R.has(value, stackedModes) ? {
    stackedMode: value
  } : {};
};
var stackedStateFromNewProps = exports.stackedStateFromNewProps = function stackedStateFromNewProps(props, state) {
  var data = props.data,
    type = props.type;
  if (!isStacked(type)) {
    return toStackedState(undefined, undefined);
  }
  if (R.isNil(data)) {
    return {};
  }
  var dimensions = (0, _utils.getDimensionsWithValues)(data);
  if (R.isEmpty(dimensions)) {
    return (0, _extends3.default)({}, toStackedState(undefined, undefined), {
      baseline: [],
      highlight: []
    });
  }
  var dimension = getStackedDimension(data, state);
  if (R.isNil(dimension)) {
    var _splitDimensions2 = (0, _.splitDimensions)(data),
      value = _splitDimensions2.value,
      values = _splitDimensions2.values;
    if (R.length(values) === 1) {
      dimension = R.head(value);
    } else {
      var _getGroupedDimensions = (0, _utils.getGroupedDimensions)(data),
        area = _getGroupedDimensions.area,
        time = _getGroupedDimensions.time,
        other = _getGroupedDimensions.other;
      if (!R.isNil(area) && !R.isEmpty(area)) {
        dimension = R.head(area);
      } else if (!R.isNil(time) && !R.isEmpty(time)) {
        dimension = R.head(time);
      } else {
        dimension = R.head(other);
      }
    }
  }
  var _mode = R.prop('stackedMode', state);
  var mode = R.has(_mode, stackedModes) ? _mode : _constants.VALUES;
  var stackedState = toStackedState(dimension, mode);
  return (0, _extends3.default)({}, stackedState, (0, _focus.focusStateFromNewProps)(props, toStackedSingularity(stackedState), state));
};